export enum ScheduleChannelsMapped {
  TELEORIENTATION = 'TELEORIENTATION'
}

export enum ScheduleCreateChannels {
  'NOT_PROVIDED' = 1,
  'CALL_CENTER' = 2,
  'CONECTA' = 3,
  'LOGGEDOUT_PLATFORM' = 4,
  'QSAUDE_APP' = 5,
  'SCHEDULE_PLATFORM_MOBILE' = 6,
  'SCHEDULE_PLATFORM_WEB' = 7,
  'WHATSAPP' = 8
}

export enum ScheduleChannels {
  CLINIC_WEB = 1,
  SGH = 2,
  TELEMEDICINE_B2C = 3,
  WISE = 4,
  MDA_SCHEDULE = 5,
  SALES_FORCE = 6
}
